import { createVNode, render } from 'vue';
import GestureController from './gestureController.vue'; // 确保路径正确

// 单例容器
let container = null;
let componentInstance = null;
let activeCallback = null;

// 初始化函数
function initInstance() {
  if (container) return;

  // 1. 创建 DOM 容器
  container = document.createElement('div');
  document.body.appendChild(container);

  // 2. 创建虚拟节点 (VNode)
  // 并监听组件发出的 gesture-detected 事件
  const vnode = createVNode(GestureController, {
    onGestureDetected: (name) => {
      if (activeCallback) {
        // 将控制器实例传回去，方便外部调用 close()
        activeCallback(name, { close: closeGesture });
      }
    }
  });

  // 3. 渲染到容器
  render(vnode, container);

  // 4. 获取组件实例 (通过 exposed)
  componentInstance = vnode.component.exposed;
}

// === 导出的方法 ===

export function openGesture(callback) {
  if (!container) initInstance();
  
  // 更新当前回调
  activeCallback = callback;
  
  // 调用组件内部的 open
  if (componentInstance) {
    componentInstance.open();
  }
}

export function closeGesture() {
  if (componentInstance) {
    componentInstance.close();
  }
  // 也可以选择在这里 activeCallback = null;
}

// === Vue 3 插件形式 (可选，为了用 this.$listenGesture) ===
export default {
  install: (app) => {
    // 挂载全局属性
    app.config.globalProperties.$listenGesture = openGesture;
    app.config.globalProperties.$closeGestureController = closeGesture;
  }
};